var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGratifyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 148,
    viewBox: "0 0 151 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.366 89.4638C150.753 127.843 138.408 141.562 99.1814 147.012C49.5457 153.9 2.8491 124.464 0.0963431 68.6994C-2.59907 13.8693 51.7966 -13.2366 96.2709 6.34871C135.326 23.5469 147.369 57.7277 150.366 89.4638Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.409 88.4621C146.775 124.714 135.081 137.672 97.9184 142.82C50.8951 149.326 6.65618 121.522 4.0483 68.8487C1.49476 17.0578 53.0275 -8.54557 95.1611 9.95407C132.16 26.199 143.57 58.4851 146.409 88.4621ZM73.7411 109.678C99.5075 109.841 114.313 98.0515 114.652 77.107C115.155 46.9534 94.9302 25.6013 65.6594 25.3433C40.1783 25.126 24.2594 39.1705 24.2322 61.8808C24.205 89.2906 45.1224 109.488 73.7411 109.678Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7411 109.678C99.5075 109.841 114.313 98.0515 114.652 77.107C115.155 46.9534 94.9302 25.6013 65.6594 25.3433C40.1783 25.126 24.2594 39.1705 24.2322 61.8808C24.205 89.2906 45.1224 109.488 73.7411 109.678Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.409 88.4621C146.775 124.714 135.081 137.672 97.9184 142.82C50.8951 149.326 6.65618 121.522 4.0483 68.8487C1.49476 17.0578 53.0275 -8.54557 95.1611 9.95407C132.16 26.199 143.57 58.4851 146.409 88.4621ZM73.7412 109.678C99.5075 109.841 114.313 98.0515 114.652 77.107C115.155 46.9534 94.9302 25.6013 65.6594 25.3433C40.1783 25.1259 24.2594 39.1705 24.2322 61.8807C24.205 89.2906 45.1224 109.488 73.7412 109.678Z",
    fill: "url(#paint0_radial_2755_2502)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0806 96.5165C53.7881 96.2177 38.3038 80.5976 38.8335 60.9706C39.2002 47.5102 49.4144 38.8308 64.8851 38.8308C85.558 38.8308 102.604 56.3389 101.803 76.7266C101.328 88.7472 90.1218 96.7475 74.0806 96.5165ZM65.2519 48.3387C57.5233 49.3302 51.4111 53.6495 51.2753 62.261C51.153 70.2748 56.7083 74.7435 64.8308 74.7842C72.9261 74.825 78.5357 70.4649 78.5629 62.4375C78.5901 54.9806 74.2708 49.4525 65.2519 48.3523V48.3387Z",
    fill: "url(#paint1_radial_2755_2502)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2755_2502",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.187 73.8554) rotate(90) scale(69.8982 71.2299)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6B9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E11F60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2755_2502",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.3252 67.6761) rotate(90) scale(28.8453 31.5049)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6B9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E11F60"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGratifyLogo);
export default __webpack_public_path__ + "static/media/gratifyLogo.79963bd337fb31cc6ac1636b90125efc.svg";
export { ForwardRef as ReactComponent };